import { customerApi } from "../utils/apiConfig";

export const setReminderDocument = (formData) => {
  return customerApi.post("/reminderDocuments", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
export const upsertReminderDocuments = (formData) => {
  return customerApi.post("/upsertReminderDocuments", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};




export const getReminderDocuments = () => {
  return customerApi.get("/getReminderDocuments", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getUserlist = () => {
  return customerApi.get("/getUserlist", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
